import React, { Component } from "react";
import { Badge, Media, Container, Row, Col } from "reactstrap";
import { Parser } from "html-to-react";
import MetaTags from 'react-meta-tags';
import './blog.css';

const BlogContent = ({ blog }) => {
  // console.log(blog);
  const body = Parser().parse(blog.body);
  const biliner = Parser().parse(`<b>${blog.byliner}</b>`);

  return (
    <>
      <div className="section pt-1">
        {
          <MetaTags>
            <meta property="og:description" content={blog.meta_description} />
            <meta property="og:title" content={blog.meta_title} />
            <meta property="og:image:secure_url" itemProp="image" content={`https://team.dtutimes.com/api/v1/images/get/${blog.cover}?thumbnail=true`} />
            <meta property="og:type" content="website" />
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:image:width" content="300" />
            <meta property="og:image:height" content="300" />
          </MetaTags>
        }
        <Container>
          <Row>
            <Col></Col>
            <Col md="10">
              <div
                className="blog-content"
                style={{
                  textAlign: "justify",
                  color: "#494850",
                  lineHeight: "2rem !important",
                  fontWeight: "400 !important"
                }}
              >
                <img
                  alt="..."
                  className="img-rounded img-responsive mb-5"
                  src={`https://team.dtutimes.com/api/v1/images/get/${blog.cover}`}
                  style={{ zIndex: "99" }}
                />
                <br />
                <b><i>{biliner}</i></b>
                <hr />
                {body}
                <hr />
                <Container>
                  <Row>
                    <Media>
                      <a className="pull-left">
                        <div className="avatar big-avatar">
                          <Media
                            alt={blog.user.name}
                            object
                            src={blog.user && `https://team.dtutimes.com/api/v1/images/get-avatar/${blog.user._id}?thumbnail=true`}
                          />
                        </div>
                      </a>
                      <Media body>
                        <Media heading>
                          {blog.user && <span>{blog.user.name}</span>}
                        </Media>
                        <p>{blog.user && <span>{blog.user.bio}</span>}</p>
                      </Media>
                    </Media>
                  </Row>
                </Container>
              </div>
            </Col>
            <Col></Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

class Single extends Component {
  state = {
    index: 0,
    currentBlogData: {},
    nextBlogData: {},
    blogBody: "",
    nextBlogSlug: "",
    currentblogSlug: "",
    blogPosts: [],
    loaded: false,
    scrollPosition: 0
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ loaded: true });
    }, 1200);

  }
  render() {
    if (this.state.loaded === true) {
      var { currentBlogData, blogBody, blogPosts } = this.state;
      if (!currentBlogData) {
        console.log("no data");
        return <div></div>;
      }
      if (!blogPosts) {
        console.log("no data");
        return <div></div>;
      }
      var htmlToReactParser = new Parser();
      blogBody = htmlToReactParser.parse(currentBlogData.body);
      return (
        <>
          <div className="wrapper">
            <div className="main">
              <div className="section section-white">
                <Container>
                  <Row>
                    <Col className="ml-auto mr-auto" md="8">
                      <div className="text-center">
                        <Badge className="main-tag" color="warning">
                          Trending
                        </Badge>
                        <h6 className="title-uppercase">
                          {currentBlogData.media &&
                            " " + currentBlogData.media[0].created_at}
                        </h6>
                      </div>
                    </Col>
                    <Col className="ml-auto mr-auto" md="8">
                      <div className="article-content">{blogBody}</div>
                      <hr />
                      <Container>
                        <Row>
                          <Media>
                            <a className="pull-left">
                              <div className="avatar big-avatar">
                                <Media
                                  alt="..."
                                  object
                                  src={
                                    currentBlogData.user &&
                                    currentBlogData.user.imgUrl
                                  }
                                />
                              </div>
                            </a>
                            <Media body>
                              <Media heading>
                                {currentBlogData.user && (
                                  <span>{currentBlogData.user.name}</span>
                                )}
                              </Media>
                              <p>
                                {currentBlogData.user && (
                                  <span>{currentBlogData.user.bio}</span>
                                )}
                              </p>
                            </Media>
                          </Media>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                  {/* <Row>
                  <div className="related-articles">
                    <h3 className="title">Recent Articles</h3>
                    <legend />
                    <Container>
                      <Row>
                        <Col md="4">
                          <a>
                            <img
                              alt="..."
                              className="img-rounded img-responsive"
                              src={blogPosts && (blogPosts[0].imgUrl)}
                            />
                          </a>
                          <p className="blog-title">
                            {blogPosts && (blogPosts[0].title)}
                          </p>
                        </Col>
                        <Col md="4">
                          <a>
                            <img
                              alt="..."
                              className="img-rounded img-responsive"
                              src={blogPosts && (blogPosts[0].imgUrl)}
                            />
                          </a>
                              <p className="blog-title">{blogPosts && (blogPosts[0].title)}</p>
                        </Col>
                        <Col md="4">
                          <a>
                            <img
                              alt="..."
                              className="img-rounded img-responsive"
                              src={blogPosts && (blogPosts[0].imgUrl)}
                            />
                          </a>
                          <p className="blog-title">
                          {blogPosts && (blogPosts[0].title)}
                          </p>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Row> */}
                </Container>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          Loading...
        </>
      );
    }
  }
}
export default BlogContent;
